import React, { useState, useEffect } from 'react';
import './../../Styles/leadstyles/ViewLeads.css';
import { useConfirm } from '../ConfirmDialog';
import { useToast } from '../ToastContext';
const apiUrl = process.env.REACT_APP_API_URL;

const ViewLeads = ({ managerId }) => {
  const [leads, setLeads] = useState([]);
  const [error, setError] = useState('');
  const confirm = useConfirm();
  const showToast = useToast();

  const effectiveManagerId = managerId || localStorage.getItem('employeeId') || '';

  useEffect(() => {
    // Fetch leads when the component mounts
    fetchLeads();
  }, [effectiveManagerId]);

  const fetchLeads = () => {
    fetch(`${apiUrl}/api/view-leads?managerId=${encodeURIComponent(effectiveManagerId)}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setLeads(Array.isArray(data) ? data : []);
        console.log('Fetched leads:', data); // Debugging output to check leads data structure
      })
      .catch((error) => {
        console.error('Error fetching leads:', error);
        setError('Error fetching leads. Please try again.');
      });
  };

  const handleChangeRole = async (employeeNumber) => {
    console.log('Changing role for lead ID:', employeeNumber);

    if (!employeeNumber) {
      showToast('Invalid lead ID', 'error');
      return;
    }

    const ok = await confirm({
      title: 'Remove Lead',
      message: 'Are you sure you want to remove this lead? Their role will be changed back to employee.',
      confirmLabel: 'Remove',
      cancelLabel: 'Cancel',
      variant: 'danger'
    });
    if (!ok) return;

    fetch(`${apiUrl}/api/change-lead-role/${employeeNumber}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Failed to change role');
        return response.json();
      })
      .then((data) => {
        showToast(data.message, 'success');
        fetchLeads();
      })
      .catch((error) => {
        console.error('Error changing lead role:', error);
        showToast('Error changing lead role. Please try again.', 'error');
      });
  };

  return (
    <div className="view-leads">
      <h3>View Leads</h3>

      {error && <div className="error-message">{error}</div>}

      {leads.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Employee Number</th>
              <th>Full Name</th>
              <th>Job Title</th>
              <th>Project</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((lead) => (
              <tr key={lead.employee_number}>
                <td>{lead.employee_number}</td>
                <td>{lead.full_name}</td>
                <td>{lead.job_title}</td>
                <td>{lead.project_name || 'N/A'}</td>
                <td>
                  {lead.converted_by_main_manager ? (
                    <span className="non-removable-text" title="Promoted by Main Manager">View Only</span>
                  ) : (
                    <button onClick={() => handleChangeRole(lead.employee_number)}>Remove</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No leads available.</p>
      )}
    </div>
  );
};

export default ViewLeads;
